// src/components/Services.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const Services = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>Our Courses</Typography>
      <Typography sx={{ mt: 2 }}>
      At Bhagyavanti PU College-Chavadihal , we offer specialized courses like NEET full time course,summer vacation with regular classes
      </Typography>
    </Container>
  );
};

export default Services;
